import { lazy } from "react";

export const WordsPage = lazy(() => import("./ui/WordsPage"));
